import React, { useState, useEffect } from "react";
import {
  AddIcon,
  TrashCanIcon,
  EditIcon,
  Button,
  Header,
  Input,
  TextArea
} from "@fluentui/react-northstar";
import { useIntl } from "react-intl";
import { confirmAlert } from 'react-confirm-alert';
const VariablesComponent = (props) => {
  const [addNewVariable, setAddNewVariable] = useState(false);
  const [editKey, setEditKey] = useState(null);
  const [variables, setVariables] = useState({});
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("{}");
  const intl = useIntl();
  useEffect(() => {
    if (props.variables) {
      setVariables(props.variables);
    }
  }, [props.variables]);

  const handleAddOrUpdate = () => {
    const keyTrimmed = newKey.trim();
    if (!keyTrimmed) {
      alert("Variable name cannot be empty");
      return;
    }
  
    if (!newValue.trim()) {
      alert("Variable value cannot be empty");
      return;
    }
  
    try {
  
      props.setCallCenterData((prev) => {
        const prevVariables = prev.variables || {};
        const updatedVariables = { ...prevVariables };
  
        if (editKey && editKey !== keyTrimmed) {
          delete updatedVariables[editKey];
        }
        updatedVariables[keyTrimmed] = newValue;
  
        return {
          ...prev,
          variables: updatedVariables,
        };
      });
  
      setNewKey("");
      setNewValue("{}");
      setAddNewVariable(false);
      setEditKey(null);
    } catch (err) {
      alert("Invalid JSON for variable value");
    }
  };
  const confirmRemoveVariable = (VariableName) => {
    confirmAlert({
        title: intl.formatMessage({ id: "confirmation" }),
        message: intl.formatMessage({ id: "are-you-sure-to-remove" }) + VariableName + '!',
        buttons: [
            {
                label: intl.formatMessage({ id: "yes" }),
                onClick: () => handleRemove(VariableName)
            },
            {
                label: intl.formatMessage({ id: "no" }),
            }
        ]
    });
}

  const handleRemove = (key) => {
    const updatedVariables = { ...variables };
  
    // Remove the key from the variables object
    delete updatedVariables[key];
  
    // Update the props with the modified variables
    props.setCallCenterData((prev) => ({
      ...prev,
      variables: updatedVariables
    }));
  };

  const renderForm = () => (
    <div style={{ marginLeft: "50px" }}>
      <Header as="h4" content={intl.formatMessage({ id: "VARIABLE_NAME" })} />
      <Input
        value={newKey}
        style={{ width: "355px", marginLeft: "50px" }}
        onChange={(e, { value }) => setNewKey(value.trimStart())}
      />

      <Header as="h4" content={intl.formatMessage({ id: "VARIABLE_VALUE" })} />
      <TextArea
        style={{ width: "355px", marginLeft: "50px", marginTop: "10px" }}
        value={newValue}
        onChange={(e, data) => {
          setNewValue(data.value)
        }}
        resize="both"
      />
      <div style={{ marginLeft: "50px", marginTop: "5px" }}>
        <Button
          primary
          content={!editKey ? intl.formatMessage({ id: "add" }) : intl.formatMessage({ id: "update" })}
          onClick={handleAddOrUpdate}
        />
        <Button
          style={{ marginLeft: "3px" }}
          primary
          content={intl.formatMessage({ id: "cancel" })}
          onClick={() => {
            setAddNewVariable(false);
            setEditKey(null);
            setNewKey("");
            setNewValue("{}");
          }}
        />
      </div>
    </div>
  );

  return (
    <div>
      <Button
        primary
        icon={<AddIcon />}
        text
        content={intl.formatMessage({ id: "ADD_NEW_VARIABLES" })}
        onClick={() => {
          setAddNewVariable(true);
          setEditKey(null);
          setNewKey("");
          setNewValue("{}");
        }}
      />
      {addNewVariable && renderForm()}
      <Header
        style={{ paddingLeft: "15px" }}
        as="h4"
        className="report-label"
        content={intl.formatMessage({ id: "VARIABLES_LIST" })}
      />
      <div style={{ paddingLeft: "50px" }}>
      {Object.entries(variables || {}).map(([key, value]) => (
          <div key={key} style={{ marginBottom: "10px" }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <p style={{ marginBottom: '0px', width: '300px' }}>{key}</p>
              <Button
                style={{ minWidth: '50px' }}
                icon={<EditIcon />}
                text
                onClick={() => {
                  setNewKey(key);
                  setNewValue(value);
                  setEditKey(key);
                  setAddNewVariable(false);
                }}
              />
              <Button
                style={{ minWidth: '50px' }}
                icon={<TrashCanIcon />}
                text
                onClick={() => {confirmRemoveVariable(key) ;}}
              />
            </div>
            {editKey === key && renderForm()}
          </div>
        ))}
      </div>
    </div>
  );
};

export default VariablesComponent;
